// Pure decision for DropdownComponent#closeMenu's leave().then() callback.
//
// el-transition's leave() adds the `hidden` class only once its ~300ms CSS transition
// settles, not when it starts. If openMenu() runs inside that window, enter() synchronously
// clears `hidden`, but the still-pending leave() from the interrupted close then puts it
// right back — leaving the popper `display: none` while the controller (and tippy) believe
// it's open, with nothing left to reopen it. Re-clear `hidden` here if the menu is open again
// by the time leave() settles, reading the LATEST state rather than the state closeMenu began
// with.
//
// `content` is only ever null defensively: nothing sets DropdownComponent's __content back to
// null/undefined today, including disconnect() — this is cheap insurance, not load-bearing.
//
// Extracted so unit tests exercise the same function the controller calls. ENG-34697.
export function reconcileHiddenAfterLeaveSettles(content, isMenuClosed) {
  if (content && !isMenuClosed) content.target.classList.remove('hidden')
}
